import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { IAppState } from './store/interface/app.state.interface';

@Component({
    standalone: false,
    selector: 'app-root',
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnDestroy {
    title = 'ttstore';
    showAppLayout = true;
    subscriptions: Subscription[] = [];
    currentSelectedTenantId = '';
    isListeningForMessages = false;

    constructor(
        private router: Router,
        private store: Store<IAppState>,
    ) {
        this.subscriptions.push(
            this.store
                .select((state) => state.user.loggedInUser)
                .subscribe((user) => {
                    if (this.currentSelectedTenantId !== user?.tenant?.id) {
                        this.currentSelectedTenantId = user?.tenant?.id || '';
                        // ========================================================================================
                        // ------TODO: This section has been temporarily commented out under ticket #511.--------
                        // ========================================================================================
                        // if (user?.tenant?.id) {
                        //     const topic = `TENANT-${user.tenant.id}`;
                        //     this.fcmService.requestPermission(topic);
                        //     if (!this.isListeningForMessages) {
                        //         this.isListeningForMessages = true;
                        //         this.fcmService.listenForMessages();
                        //     }
                        // } else {
                        //     this.fcmService.unsubscribeFromLastTopic();
                        // }
                    }
                }),
            this.router.events
                .pipe(filter((event) => event instanceof NavigationEnd))
                .subscribe((event: NavigationEnd) => {
                    this.showAppLayout = !event.urlAfterRedirects.startsWith('/auth');
                }),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
}
